import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IWorkbookUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { INamedItem, ITypedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IWorkbook } from '../types/IWorkbook';

export interface IGetWorkbooksParams extends IGetItemsParams {
}

export interface IGetWorkbooksResult extends IGetItemsResult {
  workbooks?: IWorkbook[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IWorkbookUsageInfo;
  favorites?: string[];
}

export class GetWorkbooksRequest extends Request<IGetWorkbooksParams, IGetWorkbooksResult> {
  constructor(params: IGetWorkbooksParams) {
    super('getWorkbooks', params);
  }
}
